var _g, _g2, _g3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSecure(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "48px",
    height: "48px",
    viewBox: "0 0 1024 1024",
    className: "icon",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "#000000",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_bgCarrier",
    strokeWidth: 0
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_tracerCarrier",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_iconCarrier"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M810.666667 149.333333H213.333333c-23.466667 0-42.666667 19.2-42.666666 42.666667v128c0 23.466667 19.2 42.666667 42.666666 42.666667h597.333334c23.466667 0 42.666667-19.2 42.666666-42.666667V192c0-23.466667-19.2-42.666667-42.666666-42.666667zM810.666667 405.333333H213.333333c-23.466667 0-42.666667 19.2-42.666666 42.666667v128c0 23.466667 19.2 42.666667 42.666666 42.666667h535.466667c27.733333-27.733333 104.533333-19.2 104.533333-42.666667v-128c0-23.466667-19.2-42.666667-42.666666-42.666667zM733.866667 661.333333H213.333333c-23.466667 0-42.666667 19.2-42.666666 42.666667v128c0 23.466667 19.2 42.666667 42.666666 42.666667h597.333334c23.466667 0 42.666667-19.2 42.666666-42.666667v-51.2c0-66.133333-53.333333-119.466667-119.466666-119.466667z",
    fill: "#D171C7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M917.333333 981.333333l-42.666666 42.666667h-42.666667l-42.666667-42.666667V755.2h128V853.333333l-21.333333 21.333334 21.333333 21.333333v21.333333l-21.333333 21.333334 21.333333 21.333333z",
    fill: "#FFA000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1013.333333 608c-6.4-19.2-21.333333-34.133333-42.666666-38.4-27.733333-6.4-70.4-14.933333-117.333334-14.933333s-89.6 8.533333-117.333333 12.8c-21.333333 4.266667-36.266667 19.2-42.666667 38.4-4.266667 21.333333-10.666667 46.933333-10.666666 76.8s6.4 55.466667 10.666666 74.666666c6.4 19.2 21.333333 34.133333 42.666667 38.4 27.733333 6.4 68.266667 12.8 117.333333 12.8s89.6-8.533333 117.333334-12.8c21.333333-4.266667 36.266667-19.2 42.666666-38.4 6.4-19.2 10.666667-44.8 10.666667-74.666666s-6.4-55.466667-10.666667-74.666667zM915.2 661.333333h-121.6c-12.8 0-23.466667-10.666667-23.466667-23.466666v-29.866667c0-6.4 38.4-12.8 85.333334-12.8s85.333333 6.4 85.333333 12.8v29.866667c-2.133333 12.8-12.8 23.466667-25.6 23.466666z",
    fill: "#FFA000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M832 791.466667h21.333333V1024h-21.333333z",
    fill: "#D68600"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSecure);
export default __webpack_public_path__ + "static/media/secure.b741f9a38789d764f7d4892183f3b406.svg";
export { ForwardRef as ReactComponent };